import React from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import defaultCss from './WebButton.module.scss';
import classnames from 'classnames';

const WebButton = ({ onClick, type, portal, compStyles }) => {
    const css = { ...defaultCss, ...compStyles };
    return (
        <div
            onClick={onClick}
            className={
                type === 'next'
                    ? classnames(css.buttonArrow, css.buttonArrowNext)
                    : classnames(css.buttonArrow, css.buttonArrowPrev)
            }
        >
            <div className={classnames(css.arrowCircle)}>
                {portal
                    ? svgSprite(type === 'next' ? 'angle-right' : 'angle-left', {
                          width: 11,
                          height: 20,
                          fill: 'var(--whiteColor)'
                      })
                    : svgSprite(type === 'next' ? 'angle-right' : 'angle-left', {
                          width: '8px',
                          height: '14px',
                          fill: 'var(--whiteColor)'
                      })}
            </div>
        </div>
    );
};
export default WebButton;
